<template>
  <div class="content-warp">
    <div class="menu-tab-warp bg-white">
      <div class="menu-tab-left">
        <a-menu
          mode="inline"
          :style="{ border: '0', width: 'auto' }"
          :selectedKeys="[selectedTab]"
          type="inner"
          @click="handleTabMenuClick"
        >
          <a-menu-item key="accountSettings">{{
            $t('userCenter.tabAccountSettings')
          }}</a-menu-item>
          <a-menu-item key="changePassword">{{
            $t('userCenter.tabChangePassword')
          }}</a-menu-item>
          <a-menu-item key="refreshInterval">{{
            $t('userCenter.tabRefreshInterval')
          }}</a-menu-item>
          <a-menu-item key="miniprogSettings">{{
            $t('userCenter.tabMiniprogSettings')
          }}</a-menu-item>
          <a-menu-item key="glassesSettings">{{
            $t('userCenter.tabGlassesSettings')
          }}</a-menu-item>
          <a-menu-item key="navigateSettings">导航设置</a-menu-item>
          <a-menu-item key="extFieldsSettings">扩展字段设置</a-menu-item>
          <a-menu-item key="workFlowSettings">访客预约审核流程设置</a-menu-item>
<!--          <a-menu-item key="notices">系统通知设置</a-menu-item>-->
          <!-- <a-menu-item key="visitorDeviceSettings">{{$t('userCenter.tabVisitorDeviceSettings')}}</a-menu-item> -->
        </a-menu>
      </div>
      <div class="menu-tab-right">
        <keep-alive>
          <AccountSettings v-if="selectedTab === 'accountSettings'" />
          <ChangePassword v-if="selectedTab === 'changePassword'" />
          <RefreshInterval v-if="selectedTab === 'refreshInterval'" />
          <MiniprogSettings v-if="selectedTab === 'miniprogSettings'" />
          <NavigateSettings v-if="selectedTab === 'navigateSettings'" />
          <GlassesSettings v-if="selectedTab === 'glassesSettings'" />
          <ExtFieldsSettings v-if="selectedTab === 'extFieldsSettings'" />
          <WorkFlowSettings v-if="selectedTab === 'workFlowSettings'" />
<!--          <NoticesSettings v-if="selectedTab === 'notices'" />-->
          <!-- <VisitorDeviceSettings v-if="selectedTab === 'visitorDeviceSettings'" /> -->
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import AccountSettings from './accountSettings'
import ChangePassword from './changePassword'
import RefreshInterval from './refreshInterval'
import MiniprogSettings from './miniprogSettings'
import GlassesSettings from './glassesSettings'
import NavigateSettings from './navigateSettings'
import ExtFieldsSettings from './extFieldsSettings'
import WorkFlowSettings from './workFlowSettings'
// import VisitorDeviceSettings from './visitorDeviceSettings';

export default {
  name: 'userCenterIndex',
  components: {
    AccountSettings,
    ChangePassword,
    RefreshInterval,
    MiniprogSettings,
    GlassesSettings,
    NavigateSettings,
    ExtFieldsSettings,
    WorkFlowSettings,
    // VisitorDeviceSettings
  },
  data() {
    return {
      selectedTab: 'accountSettings'
    }
  },
  computed: {},
  methods: {
    handleTabMenuClick(data) {
      this.selectedTab = data.key
    }
  }
}
</script>

<style lang="less" scoped>
// .tab-panle{
//   background-color: #fff;
//   box-shadow:0 0 20px #e8e8e8;
//   border-radius: 5px;
// }
// .table-title{
//   margin-bottom: 0;
//   height: 50px;
//   line-height: 40px;
//   font-size: 16px;
//   border-bottom: 1px solid #e8e8e8;
// }
// .table-title:before {
//   content: "";
//   margin-right: 10px;
//   border: 2px solid #1890ff;
//   border-radius: 5px;
// }

.menu-tab-warp {
  width: 100%;
  display: flex;
  // height: 100%;
  // overflow: auto;
  padding: 16px 0;

  .menu-tab-left {
    border-right: 1px solid #e8e8e8;
    width: 224px;

    .ant-menu-item {
      text-align: center;
    }
  }

  .menu-tab-right {
    flex: 1 1;
  }
}
</style>
